var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", {
    ref: "channels",
    attrs: { size: _vm.modalSize, loading: _vm.loading },
    on: {
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "modal-title",
        fn: function() {
          return [
            _c("h3", [
              _c("i", { staticClass: "fas fa-pencil-alt text-warning" }),
              _vm._v(" Edit channels")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "modal-body",
        fn: function() {
          return _vm._l(_vm.channels, function(channel) {
            return _c("Checkbox", {
              key: channel.id,
              staticClass: "checkbox",
              attrs: {
                label: channel.name,
                value: _vm.channelValues[channel.id].value
              },
              on: {
                input: function($event) {
                  _vm.values[channel.id].value = $event
                }
              }
            })
          })
        },
        proxy: true
      },
      {
        key: "modal-footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: {
                  click: function($event) {
                    return _vm.cancel()
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.resource("Button_Cancel")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-primary",
                on: {
                  click: function($event) {
                    return _vm.saveChannels()
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.resource("Button_Save")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }